export const getFilledSlotCount = (slots) => {
  const filtered = slots.filter(
    (slotData) => slotData.solution || slotData.rotor
  );
  return filtered.length;
};

export const checkSolutionPresent = (slots) => {
  const result = slots.find((slotData) => slotData.solution);
  if (result) return true;
  else return false;
};

export const checkRotorPresent = (slots) => {
  const result = slots.find((slotData) => slotData.rotor);
  if (result) return true;
  else return false;
};
